import { render, staticRenderFns } from "./LayoutCMSSidebar.vue?vue&type=template&id=36995a42"
var script = {}
import style0 from "./LayoutCMSSidebar.vue?vue&type=style&index=0&id=36995a42&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports